import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { CgMenuRight } from "react-icons/cg";
import { motion } from "framer-motion";
import {
  BsInstagram,
  BsLinkedin,
  BsMoonFill,
  BsFillSunFill,
  BsGithub,
} from "react-icons/bs";
import { ScrollLink } from "./ScrollLink.js";
import { MenuContext } from "../context/MenuContext";

// 🧩 Animation variants for sliding mobile menu using Framer Motion
const menuVariants = {
  hidden: {
    x: "100%",
  },
  show: {
    x: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.9],
    },
  },
};

const MobileNav = ({ theme, handleThemeSwitch }) => {
  // 🧩 State to track if mobile menu is open
  const [openMenu, setOpenMenu] = useState(false);

  // 🧩 Handle theme switch and close menu at the same time
  const changeTheme = () => {
    setOpenMenu(false);
    handleThemeSwitch();
  };

  return (
    // 🧩 Context provider to allow nested components to close menu
    <MenuContext.Provider value={{ closeMenu: () => setOpenMenu(false) }}>
      {/* 🧩 Only show on smaller screens (xl:hidden) */}
      <nav className="text-primary xl:hidden dark:text-powder ">
        {/* 🧩 Hamburger icon to open mobile menu */}
        <div
          onClick={() => setOpenMenu(true)}
          className="text-3xl cursor-pointer dark:text-powder "
        >
          <CgMenuRight />
        </div>

        {/* 🧩 Mobile Menu Panel with slide-in animation */}
        <motion.div
          variants={menuVariants}
          initial="hidden"
          whileInView={openMenu ? "show" : ""}
          className="bg-beige shadow-2xl w-full absolute top-0 right-0 max-w-xs h-screen z-20 dark:bg-mate2"
        >
          {/* 🧩 Close icon inside the menu */}
          <div
            onClick={() => setOpenMenu(false)}
            className="text-4xl absolute z-30 left-4 top-14 text-primary cursor-pointer dark:text-powder "
          >
            <IoMdClose />
          </div>

          {/* 🧩 Navigation Links */}
          <ul className="h-full flex flex-col justify-center items-center gap-y-8 text-primary font-primary  font-bold text-3xl dark:text-powder">
            {/* 🧩 Scroll to section and close menu on click */}
            <li>
              <ScrollLink
                section="home"
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                onClick={() => setOpenMenu(false)}
              >
                Home
              </ScrollLink>
            </li>
            <li>
              <ScrollLink
                section="about"
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                onClick={() => setOpenMenu(false)}
              >
                About
              </ScrollLink>
            </li>
            <li>
              <ScrollLink
                section="portfolio"
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                onClick={() => setOpenMenu(false)}
              >
                Portfolio
              </ScrollLink>
            </li>
            <li>
              <ScrollLink
                section="testimonials"
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                onClick={() => setOpenMenu(false)}
              >
                Reflections
              </ScrollLink>
            </li>
            <li>
              <ScrollLink
                section="contact"
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                onClick={() => setOpenMenu(false)}
              >
                Contact
              </ScrollLink>
            </li>

            {/* 🧩 Navigate to blog page */}
            <li>
              <RouterLink
                onClick={() => setOpenMenu(false)}
                className="text-[#696c6d] hover:text-primary transition nav-link cursor-pointer"
                to="/blog"
              >
                Blog
              </RouterLink>
            </li>
            {/* 🧩 Social icons and theme toggle button */}
            <li>
              <ul className="flex gap-x-4">
                <li>
                  <a
                    href="https://www.instagram.com/_guruleo_/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsInstagram />
                  </a>
                </li>
                <li>
                  <a
                    href="http://www.linkedIn.com/in/guruprakash-leo"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsLinkedin />
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/Guru-Leo-Dev"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsGithub />
                  </a>
                </li>

                {/* 🧩 Theme toggle button (moon/sun icon) */}
                <li>
                  <button onClick={changeTheme} className="">
                    {theme === "light" ? <BsMoonFill /> : <BsFillSunFill />}
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </motion.div>
      </nav>
    </MenuContext.Provider>
  );
};

export default MobileNav;
